import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 px-4 border-t border-brown/10 mt-auto" data-id="element-96">
      <p className="font-serif text-xs text-center text-text/50 max-w-lg mx-auto leading-relaxed" data-id="element-97">
        Disclaimer: Dies ist ein persönlicher Erfahrungsbericht. Ergebnisse
        können individuell variieren. Bei anhaltenden Beschwerden bitte einen
        Tierarzt aufsuchen.
      </p>
    </footer>;
}